import { useEffect, useState } from "react";

export const usePriceListStepForm = (
  priceListStep: number | null | undefined,
) => {
  const [priceStep, setPriceStep] = useState<number | "">("");

  const resetPriceListStepForm = () => {
    setPriceStep("");
  };

  useEffect(() => {
    if (priceListStep === null || priceListStep === undefined) {
      return;
    }

    setPriceStep(priceListStep);
  }, [priceListStep]);

  return {
    priceStep,
    setPriceStep,
    resetPriceListStepForm,
  };
};
